const CaseList = () => import('Views/case/case-list');
const CaseDetail = () => import('Views/case/case-detail');

export default[
  { path: '/case-list', component: CaseList },
  { path: '/case-detail/:id', component: CaseDetail },
];



// WEBPACK FOOTER //
// ./src/router/case.js